import { Filter } from '../types';

export const catBreeds = [
  'Persian', 'Maine Coon', 'Siamese', 'Ragdoll', 'Bengal',
  'British Shorthair', 'Abyssinian', 'Scottish Fold', 'Sphynx',
  'Russian Blue', 'Norwegian Forest Cat', 'Birman', 'American Shorthair',
  'Devon Rex', 'Oriental Shorthair', 'Cornish Rex', 'Tonkinese',
  'Turkish Angora', 'Somali', 'Manx', 'Burmese', 'Egyptian Mau',
  'Chartreux', 'Balinese', 'Exotic Shorthair'
];

export const dogBreeds = [
  'Labrador Retriever', 'German Shepherd', 'Golden Retriever', 'French Bulldog',
  'Bulldog', 'Poodle', 'Beagle', 'Rottweiler', 'German Shorthaired Pointer',
  'Yorkshire Terrier', 'Dachshund', 'Siberian Husky', 'Boxer', 'Cavalier King Charles Spaniel',
  'Shih Tzu', 'Pomeranian', 'Boston Terrier', 'Havanese', 'Shetland Sheepdog',
  'Cocker Spaniel', 'Border Collie', 'Pug', 'Maltese', 'Chihuahua'
];

export const defaultFilters: Filter[] = [
  {
    id: 'petType',
    field: 'petType',
    label: 'Pet Type',
    type: 'select',
    options: [
      { value: 'dog', label: 'Dog' },
      { value: 'cat', label: 'Cat' }
    ]
  },
  {
    id: 'breed',
    field: 'breed',
    label: 'Breed',
    type: 'select',
    options: [
      ...dogBreeds.map(breed => ({ value: `dog_${breed.toLowerCase().replace(/\s+/g, '_')}`, label: `Dog - ${breed}` })),
      ...catBreeds.map(breed => ({ value: `cat_${breed.toLowerCase().replace(/\s+/g, '_')}`, label: `Cat - ${breed}` }))
    ]
  },
  {
    id: 'sex',
    field: 'sex',
    label: 'Sex',
    type: 'select',
    options: [
      { value: 'male', label: 'Male' },
      { value: 'female', label: 'Female' }
    ]
  },
  {
    id: 'age',
    field: 'age',
    label: 'Age (years)',
    type: 'number'
  },
  {
    id: 'ageCategory',
    field: 'ageCategory',
    label: 'Age Category',
    type: 'select',
    options: [
      { value: 'puppy', label: 'Puppy (0-1 year)' },
      { value: 'adult', label: 'Adult (1-7 years)' },
      { value: 'senior', label: 'Senior (7+ years)' }
    ]
  },
  {
    id: 'weight',
    field: 'weight',
    label: 'Weight (kg)',
    type: 'number'
  },
  {
    id: 'size',
    field: 'size',
    label: 'Size',
    type: 'select',
    options: [
      { value: 'small', label: 'Small (< 10kg)' },
      { value: 'medium', label: 'Medium (10-25kg)' },
      { value: 'large', label: 'Large (25-40kg)' },
      { value: 'giant', label: 'Giant (> 40kg)' }
    ]
  },
  {
    id: 'neutered',
    field: 'neutered',
    label: 'Neutered/Spayed',
    type: 'select',
    options: [
      { value: 'true', label: 'Yes' },
      { value: 'false', label: 'No' }
    ]
  },
  {
    id: 'healthConditions',
    field: 'healthConditions',
    label: 'Health Conditions',
    type: 'select',
    options: [
      { value: 'none', label: 'None' },
      { value: 'arthritis', label: 'Arthritis' },
      { value: 'diabetes', label: 'Diabetes' },
      { value: 'heart_disease', label: 'Heart Disease' },
      { value: 'allergies', label: 'Allergies' },
      { value: 'obesity', label: 'Obesity' }
    ]
  }
];